export default {
    excellent: 'Excellent',
    fair: 'Fair',
    good: 'Good',
    poor: 'Poor',
    'very good': 'Very good',
};
